import React, { useState } from "react";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import SoftInput from "StyleFeatures/SoftInput";
import SoftButton from "StyleFeatures/SoftButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { useNavigate } from "react-router-dom";
import login from "api/authService";
import { message } from "antd";

function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

 const handleSubmit = async (e) => {
  e.preventDefault();

  setEmailError(null);
  setPasswordError(null);
  setError(null);

  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    setEmailError("Valid email required");
    return;
  }

  if (!password) {
    setPasswordError("Password required");
    return;
  }

  try {
    setIsLoading(true);

   const response = await login(email, password);
const data = response?.data;

//  HANDLE BACKEND ERROR (even if status = 200)
if (data?.success === false) {
  throw new Error(data.message || "Login failed");
}

//  TOKEN CHECK
if (!data?.token) {
  throw new Error(data?.message || "Invalid Email or Password");
}

//  ROLE CHECK
const roles = data.roles;
const primaryRole = Array.isArray(roles) ? roles[0] : roles;

if (!primaryRole) {
  throw new Error("Role not assigned. Please contact admin.");
}

    // ❌ ROLE VALIDATION (CRITICAL FIX)
    if (!primaryRole) {
      throw new Error("Role not assigned. Please contact admin.");
    }

    //  STORE DATA ONLY AFTER VALIDATION
    localStorage.setItem("userId", data.id);
    localStorage.setItem("personalId", data.personalId);
    localStorage.setItem("email", data.email);
    localStorage.setItem("token", data.token);
    localStorage.setItem("role", primaryRole);

    //  SUCCESS ONLY AFTER EVERYTHING VALID
    message.success(`Welcome ${data.fullName || "back"}! Login successful.`);

    let redirectPath = "/signIn";

    switch (primaryRole) {
      case "Admin":
        redirectPath = "/dashboard";
        break;
      case "Employee":
        redirectPath = "/employeedashboard";
        break;
      case "Finance":
        redirectPath = "/financedashboard";
        break;
      default:
        throw new Error("Invalid role. Please contact support.");
    }

    navigate(redirectPath, { replace: true });

  } catch (err) {
    console.error("Login error:", err);

    const msg =
      err.response?.data?.message ||
      err.message ||
      "Login failed";

    setError(msg);
    toast.error(msg);

  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <CoverLayout
        title="VelorHR Login"
        description="Enter your email and password to sign in"
        image={curved9}
      >
        <SoftBox component="form" role="form" onSubmit={handleSubmit}>
          <ToastContainer position="top-left" />

          {/* Email */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Email
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError(null);
              }}
              className={`form-control ${emailError ? "is-invalid" : ""}`}
            />
            {emailError && (
              <SoftTypography color="error" variant="caption">
                {emailError}
              </SoftTypography>
            )}
          </SoftBox>

          {/* Password */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Password
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(null);
              }}
              className={`form-control ${passwordError ? "is-invalid" : ""}`}
            />
            {passwordError && (
              <SoftTypography color="error" variant="caption">
                {passwordError}
              </SoftTypography>
            )}
          </SoftBox>

          {/* Error Message */}
          {error && (
            <SoftBox mb={2}>
              <SoftTypography color="error" variant="body2">
                {error}
              </SoftTypography>
            </SoftBox>
          )}

          <SoftBox textAlign="right" mb={2}>
  <SoftTypography
    variant="caption"
    color="info"
    fontWeight="medium"
    style={{ cursor: "pointer" }}
    onClick={() => navigate("/forgot-password")}
  >
    Forgot Password?
  </SoftTypography>
</SoftBox>

          {/* Submit */}
          <SoftBox mt={4} mb={1}>
            <SoftButton type="submit" variant="gradient" color="info" fullWidth>
              {isLoading ? "Please Wait..." : "Sign In"}
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginLeft: "8px" }}
                />
              )}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </CoverLayout>
    </>
  );
}

export default SignIn;
